/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ReleaseDetails_release$ref: FragmentReference;
declare export opaque type ReleaseDetails_release$fragmentType: ReleaseDetails_release$ref;
export type ReleaseDetails_release = {|
  +id: string,
  +name: string,
  +product: {|
    +id: string,
    +code: ?string,
    +title: string,
    +representativeImageUrl: ?string,
  |},
  +deadline: ?any,
  +isActive: boolean,
  +hasIncompleteDeliverables: ?boolean,
  +$refType: ReleaseDetails_release$ref,
|};
export type ReleaseDetails_release$data = ReleaseDetails_release;
export type ReleaseDetails_release$key = {
  +$data?: ReleaseDetails_release$data,
  +$fragmentRefs: ReleaseDetails_release$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ReleaseDetails_release",
  "type": "ReleaseNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "product",
      "storageKey": null,
      "args": null,
      "concreteType": "ProductNode",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "representativeImageUrl",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "deadline",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isActive",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasIncompleteDeliverables",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '7f413b5d08f1b6e7194fe82ec68737de';
module.exports = node;
